import { Box, Stack, Typography } from "@mui/material";

import LearnVisualFrame from "./LearnVisualFrame";

const considerations = ["Mining costs", "Processing & recovery", "Capital requirements", "Taxes & royalties", "Time", "Technical uncertainty", "Permitting", "Financing"];

export default function InSituValueVisual({ title, takeaway, caption, data = {} }) {
  const metal = data.metal || "2 Moz contained gold";
  const price = data.price || "$3,000/oz spot price";
  const headline = data.headline || "$6.0B in-situ value";

  return (
    <LearnVisualFrame title={title} takeaway={takeaway} caption={caption}>
      <Box sx={{ textAlign: "center" }}>
        <Stack direction={{ xs: "column", md: "row" }} spacing={1.2} alignItems="center" justifyContent="center">
          {[metal, "×", price, "=", headline].map((item) => (
            <Box
              key={item}
              sx={{
                px: item.length <= 1 ? 0.5 : 1.5,
                py: item.length <= 1 ? 0 : 1.25,
                minWidth: item.length <= 1 ? "auto" : 160,
                border: item.length <= 1 ? 0 : "1px solid rgba(34,35,37,0.12)",
                borderRadius: 1,
                backgroundColor: item.length <= 1 ? "transparent" : "rgba(255,255,255,0.72)",
                fontSize: item.length <= 1 ? 28 : 15,
                fontWeight: 900,
                color: item.length <= 1 ? "primary.main" : "text.primary",
              }}
            >
              {item}
            </Box>
          ))}
        </Stack>
        <Typography sx={{ mt: 2, fontSize: 28, fontWeight: 900, color: "primary.main" }}>≠</Typography>
        <Box sx={{ maxWidth: 620, mx: "auto", p: 1.75, border: "1px solid rgba(34,35,37,0.12)", borderRadius: 1, backgroundColor: "rgba(255,255,255,0.72)" }}>
          <Typography sx={{ fontSize: 12, fontWeight: 900, color: "text.secondary", textTransform: "uppercase", letterSpacing: 0 }}>
            Economic and technical reality
          </Typography>
          <Typography sx={{ mt: 0.45, fontSize: 18, fontWeight: 900 }}>Project value</Typography>
          <Stack direction="row" flexWrap="wrap" justifyContent="center" gap={0.75} sx={{ mt: 1.25 }}>
            {considerations.map((item) => (
              <Box key={item} sx={{ px: 0.95, py: 0.35, borderRadius: 0.75, border: "1px solid rgba(34,35,37,0.10)", fontSize: 12, fontWeight: 800, color: "text.secondary", backgroundColor: "rgba(34,35,37,0.035)" }}>
                {item}
              </Box>
            ))}
          </Stack>
        </Box>
      </Box>
    </LearnVisualFrame>
  );
}
